export const DEBUG = process.env.NODE_ENV !== "production";

export const SITE_TITLE = "Adventure Store";

export function pageTitleStory(storyTitle) {
	return `${storyTitle} | ${SITE_TITLE}`;
}
